var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsNewDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.757,
    height: 23.076,
    viewBox: "0 0 22.757 23.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16049",
    "data-name": "Group 16049",
    transform: "translate(-188.125 -287.806)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30545",
    "data-name": "Path 30545",
    d: "M5.268,11.621,3.3,13.361a1.523,1.523,0,0,0-.31,1.907l1.781,3.124a1.512,1.512,0,0,0,1.79.678l2.474-.843Z",
    transform: "translate(187.288 286.609)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30546",
    "data-name": "Path 30546",
    d: "M9.469,4.355A28.762,28.762,0,0,1,7.627,8.742a7.756,7.756,0,0,1-2.154,2.324l3.769,6.584a7.863,7.863,0,0,1,3.1-.72,29.087,29.087,0,0,1,4.689.595",
    transform: "translate(187.082 287.166)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30547",
    "data-name": "Path 30547",
    d: "M3.036,14.73l-.653.386a1.53,1.53,0,0,0,.372,2.8,1.487,1.487,0,0,0,1.15-.16l.611-.386m5.175-.219,1.832,3.2a1.551,1.551,0,0,1-.548,2.082,1.512,1.512,0,0,1-2.07-.562l-2.07-3.678M20.353,6.625,17.663,8.187m4.968,3.8H19.525M16.679,1.625,15.126,4.334M9.169,4.147l1.309-.761a1.5,1.5,0,0,1,2.065.557l6.04,10.529a1.53,1.53,0,0,1-.559,2.068l-1.309.762Z",
    transform: "translate(187.377 287.375)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewDark);
export default __webpack_public_path__ + "static/media/whatsNewDark.18aeb5d211a03728352a95ee10f076a9.svg";
export { ForwardRef as ReactComponent };